import {gql} from '@apollo/client';

export const timeTrackerMutations = {
    CREATE_TIME_TRACKER_ENTITY: gql`
        mutation CreateTimeTracker($input: TimeTrackerCreateEditRequestDTOInput!) {
            createTimeTracker(input: $input) {
                id
                description
                title
                startTime
                endTime
                status
                durationInSeconds
                itemDataId
                createdDate
                ticketNo
                itemDataURL
            }
        }
    `,
    UPDATE_TIME_TRACKER_ENTITY: gql`
        mutation UpdateTimeTracker($id: UUID!, $input: TimeTrackerCreateEditRequestDTOInput!) {
            updateTimeTracker(id: $id, input: $input) {
                id
                description
                title
                startTime
                endTime
                status
                durationInSeconds
                itemDataId
                createdDate
                ticketNo
                itemDataURL
            }
        }
    `,
    REMOVE_TIME_TRACKER_ENTITY: gql`
        mutation DeleteTimeEntries($id: UUID!) {
            deleteTimeEntries(id: $id) {
                statusCode
                message
                data
            }
        }
    `,
    STOP_TIME_TRACKER_ENTITY: gql`
        mutation StopTimeEntry($id: UUID!) {
            stopTimeEntry(id: $id) {
                id
                description
                title
                startTime
                endTime
                status
                durationInSeconds
                itemDataId
                createdDate
                ticketNo
                itemDataURL
            }
        }
    `,
};
